<template>
 <div class="ps-re">
    <div class="inline abs-tl-zero white" style="min-size: 135px;height: 26px;line-height: 26px;padding: 0 12px;">
      전체 <span>{{resultData.total ? resultData.total : 0}}</span> 건
    </div>
      <ul class="pagination mt-30 justify-content-center">
        <li :class="{'disabled' : !resultData.hasPreviousPage}" v-on:click="pageChange('1')">
            <a>
            <i class="icon-arrow-2line-left"></i>
            </a>
        </li>
        <li :class="{'disabled' : !resultData.hasPreviousPage}" v-on:click="pageChange(resultData.prePage)">
            <a >
            <i class="icon-arrow-line-left"></i>
            </a>
        </li>
        <li v-if="resultData.navigatepageNums" :class="{'active': item == resultData.pageNum}" v-for="item in resultData.navigatepageNums" :key="item" style="cursor:pointer" v-on:click="pageChange(item)">
            <a>{{item}}</a>
        </li>
        <li v-if="!resultData.total" class="active" :key="1" style="cursor:pointer">
          <a>1</a>
        </li>
        <li :class="{'disabled' : !resultData.hasNextPage}"  v-on:click="pageChange(resultData.nextPage)">
            <a>
            <i class="icon-arrow-line-right"></i>
            </a>
        </li>
        <li :class="{'disabled' : !resultData.hasNextPage}"  v-on:click="pageChange(resultData.pages)">
            <a>
            <i class="icon-arrow-2line-right"></i>
            </a>
        </li>
      </ul>
      <!--
      [D] .form-control 클릭 시, .form-group에 .has-focus 클래스 추가 // .form-control에  .form-control-focus 클래스 추가
      .dropdown-item에 hover 시, .has-focus, .form-control-focus 클래스 삭제
      -->

      <div class="dropdown inline abs-br-zero dropup" v-show="!isLimitHide">
        <Dropdown v-show="!isLimitHide" :datasource="limitDataSource" displayName="name" valueName="value" :isSelectionFirstData="true" @changeValue="pageSizeChange" :editMode="false" :isEdit="true" :isFieldMode="false" :width="100"/>
      </div>
    </div>
</template>

<script>
/*
 "pageNum": 1,
  "pageSize": 1,
  "size": 1,
  "startRow": 1,
  "endRow": 1,
  "pages": 27,
  "prePage": 0,
  "nextPage": 2,
  "isFirstPage": true,
  "isLastPage": false,
  "hasPreviousPage": false,
  "hasNextPage": true,
  "navigatePages": 8,
  "navigatepageNums": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8
  ],
  "navigateFirstPage": 1,
  "navigateLastPage": 8*/
import Dropdown from '@/components/Dropdown';
export default {
    //props: ['datasource','isLimitHide'],
    props: {
        datasource: Object,
        isLimitHide: Boolean,
        pageData: {
            type: Object,
            default: function() {
                return {"limit" : "20", "offset" : "1"};
            }
        },
        limitData: {
            type: Array,
            default: function() {
                return  [{name: '20개씩', value: '20'}, {name: '30개씩', value: '30'}, {name: '50개씩', value: '50'}]
            }
        },
    },
    computed: {
        limitDataSource() {
            return this.limitData;
        }
    },
    mounted(){
        var query = this.$route.query;

        if(query.limit && query.offset){
            this.paging.limit = query.limit;
            this.paging.offset = query.offset;
        }
    },
    methods: {
        pageChange(index){
          console.log('a')
            if($(event.currentTarget).hasClass('disabled')){
              console.log('b')
                event.stopPropagation();
                event.preventDefault ();
                return;
            }
            if("a : " +  index != this.paging.offset) {
              console.log('c')
                this.paging.offset = index.toString();
                this.$emit("pageChange",{eventName:'pageChange', data: this.paging});
            }
        },
        pageSizeChange(event){
            if(event.data.value != this.paging.limit) {
                this.paging.limit = event.data.value;
                this.$emit("pageChange",{eventName:'pageChange', data: this.paging});
            }
        }
    },
    data(){
        return {
            items: [{}],
            paging: this.pageData,
            //limitDataSource: this.limitData,
            total: 0,
            resultData: {
                "pageNum": null,
                "pageSize": null,
                "size": null,
                "startRow": null,
                "endRow": null,
                "pages": null,
                "prePage": null,
                "nextPage": null,
                "isFirstPage": null,
                "isLastPage": null,
                "hasPreviousPage": null,
                "hasNextPage": null,
                "navigatePages": null,
                "navigatepageNums": null,
                "navigateFirstPage": null,
                "navigateLastPage": null,
                "list" : null
            }
        }
    },
    watch: {
        datasource : function (newVal, oldVal) {
            if(newVal != oldVal){
                this.resultData = newVal;

            }
        },
        /*
        $route (newVal, oldVal) {
            if(newVal != oldVal){
                this.paging.limit = newVal.query.limit;
                this.paging.offset = newVal.query.offset;
            }
        },
        */
    },
    components: {
        Dropdown
    }
}
</script>

<style>

</style>
